// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5173":"2ab47011","7078":"2ab47011"}[chunkId] + ".chunk.css";
};